// ─────────────────────────────────────────────────────────────
// EDITABLE REVIEWS DATA
// No Google Reviews API is connected, so NO review quotes are
// shown. Entries below are explicit placeholders. When real,
// verified reviews are available, add them as objects with
// { author, rating, text, date } and placeholder: false.
// Rating summary values come from config/site.js (editable).
// ─────────────────────────────────────────────────────────────

export const reviews = [
  { id: "r1", placeholder: true },
  { id: "r2", placeholder: true },
  { id: "r3", placeholder: true },
];

export const placeholderReviewText =
  "Verified Google review will appear here.";
